import { motion } from "framer-motion";
import { BookOpen, Monitor, Award, Users, Briefcase, Folder } from "react-feather";
import PageShell from "../../components/premium/layout/PageShell";
import PageHero from "../../components/premium/layout/PageHero";
import SectionHeading from "../../components/premium/layout/SectionHeading";
import MagneticButton from "../../components/premium/hero/MagneticButton";
import CurriculumSection from "../../components/CurriculumSection";
import eduImg from "../../assets/images/edu-pravahaa-logo.png";

const benefits = [
  { icon: Briefcase, title: "3-Month Internship", desc: "Guaranteed industry experience with certificate." },
  { icon: Monitor, title: "Online + Offline", desc: "Live classes plus hands-on practice at our centre." },
  { icon: Users, title: "Placement Support", desc: "Resume, mocks, and job referrals until placed." },
  { icon: Award, title: "Certificates", desc: "Course completion + internship credentials." },
  { icon: Folder, title: "Lifelong LMS", desc: "Free access to courses, recordings & resources." },
  { icon: BookOpen, title: "Expert Trainers", desc: "Learn from industry professionals." },
];

export default function EduPravahaaPage() {
  return (
    <PageShell>
      <PageHero
        badge="Digital Education"
        title="Edu"
        highlight="Pravahaa"
        subtitle="Industry-aligned programs in Full Stack, Testing, and AWS DevOps — now open for enrollment."
      >
        <div className="inline-flex mx-auto mt-6 px-8 py-5 rounded-2xl bg-white shadow-xl">
          <img src={eduImg} alt="Edu Pravahaa" className="max-h-32 object-contain" />
        </div>
      </PageHero>

      <section className="py-16 premium-section-alt">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionHeading badge="Why Enroll" title="What You Get" />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((b, i) => (
              <motion.div
                key={b.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.05 }}
                className="premium-glass rounded-2xl p-6"
              >
                <div className="w-12 h-12 rounded-xl bg-[#F5C044]/20 flex items-center justify-center text-[#F5C044] mb-4">
                  <b.icon size={22} />
                </div>
                <h3 className="font-bold text-white">{b.title}</h3>
                <p className="mt-2 text-sm text-white/55">{b.desc}</p>
              </motion.div>
            ))}
          </div>
          <div className="mt-12 text-center flex flex-wrap justify-center gap-4">
            <MagneticButton to="/enroll" variant="gold">Enroll Now</MagneticButton>
            <MagneticButton to="/launch-event" variant="glass">Launch Recap</MagneticButton>
          </div>
        </div>
      </section>

      <section className="py-8 lg:py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <CurriculumSection />
        </div>
      </section>
    </PageShell>
  );
}
